import styled from "styled-components";
import thumb from "../assets/images/awards-summit.webp";
import { useState, useEffect } from "react";

const AboutEvent = () => {

  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    if (showForm) {
      const loadForm = () => {
        if (window.hbspt) {
          const container = document.getElementById("about-hubspot-form");
          if (container) {
            container.innerHTML = "";

            window.hbspt.forms.create({
              region: "na2",
              portalId: "46890133",
              formId: "425f93b6-55f2-4ad3-9471-590c5cccc06f",
              target: "#about-hubspot-form"
            });
          }
        }
      };

      if (window.hbspt) {
        loadForm();
      } else {
        const script = document.createElement("script");
        script.src = "https://js.hsforms.net/forms/embed/v2.js";
        script.async = true;
        script.onload = loadForm;
        document.body.appendChild(script);
      }
    }
  }, [showForm]);

  return (
    <>
      <Section id="technology-summit">

        <MainHeading>
          IIT Madras Technology Summit 2026
        </MainHeading>

        <Container>

          <Left>
            <Text>
              The <Highlight>IIT Madras Technology Summit 2026</Highlight> is a premier platform that brings together industry leaders,
              policymakers, innovators, researchers, startups and academia to explore how cutting-edge technologies
              are shaping a <b>measurable, scalable, and sustainable</b> future.
            </Text>

            <Text>
              Hosted by the <b>Office of Alumni and Corporate Relations (ACR), IIT Madras</b>, the Summit showcases
              transformative ideas, real-world applications, and collaborative models that drive national and global progress.
            </Text>
          </Left>

          <Right>
            <Thumbnail>
              <Image src={thumb} alt="Technology Summit" />
            </Thumbnail>
          </Right>

        </Container>
      </Section>

      {showForm && (
        <FormModalOverlay onClick={() => setShowForm(false)}>
          <FormModalContent onClick={(e) => e.stopPropagation()}>
            <FormCloseBtn onClick={() => setShowForm(false)}>✕</FormCloseBtn>
            <div id="about-hubspot-form"></div>
          </FormModalContent>
        </FormModalOverlay>
      )}

    </>
  );
};

export default AboutEvent;


/* ================= STYLES ================= */

const Section = styled.section`
  padding: 20px 20px;
  background: ${(props) => (props.alt ? "#f9f9f9" : "#ffffff")};

  @media (max-width: 768px) {
    padding: 4px 6px;
  }
`;

const Highlight = styled.span`
  font-weight: 700;
  font-size: 18px;
  color: #171f32;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

const Container = styled.div`
  max-width: 1200px;
  margin: auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  //gap: 30px;
  align-items: center;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: 4px;
  }
`;

const Left = styled.div`
  order: ${(props) => (props.reverse ? 2 : 1)};
`;

const Right = styled.div`
  display: flex;
  justify-content: center;
  order: ${(props) => (props.reverse ? 1 : 2)};
  padding: 0;
`;

const Text = styled.p`
  font-size: 16px;
  line-height: 1.8;
  color: #333;
  margin-bottom: 15px;

  @media (max-width: 768px) {
    font-size: 12px;
    margin-bottom: 5px;
  }
`;

const Thumbnail = styled.div`
  z-index: 0;
  position: relative;
  width:100%;
  max-width: 520px;
  border-radius: 8px;
  overflow:hidden;  

  img{
    width:100%;
    display:block;
  }
`;

const FormModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.65);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2147483647;
  isolation: isolate; 
`;

const FormModalContent = styled.div`
  background: #ffffff;
  width: 90%;
  max-width: 650px;
  max-height: 90vh;
  overflow-y: auto;
  border-radius: 14px;
  padding: 40px 30px;
  position: relative;
`;

const FormCloseBtn = styled.button`
  position: absolute;
  top: 15px;
  right: 15px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  background: #d6a54f;
  color: white;
  font-size: 18px;
  cursor: pointer;

  &:hover {
    background: #bd8a32;
  }
`;

const MainHeading = styled.h2`
  text-align: center;
  font-size: 38px;
  font-weight: 700;
  color: #791e1b;
  margin-bottom: 20px;
  line-height: 1.3;

  @media (max-width: 768px) {
    font-size: 16px;
    margin-bottom: 2px;
  }
`;

const Image = styled.img`
  height: 240px;

`;
